"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var dropDownTrigger = document.querySelector('.accepted-insurance__right a');
  var dropDownContent = document.querySelector('.accepted-insurance__dropdown');
  var closeDropDown = document.querySelector('.accepted-insurance__close');
  var dictionary = [];
  var map = {};
  var searchInputElement = document.getElementById('insurance-search');
  var predictionsElement = document.getElementById('predictions');
  var searchButtonElement = document.getElementById('insurance-search-button');
  if (dropDownTrigger) {
    dropDownTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      dropDownContent.classList.toggle("active-panel");
    });
    closeDropDown.addEventListener("click", function (e) {
      if (dropDownContent.classList.contains('active-panel')) {
        dropDownContent.classList.remove('active-panel');
      }
    });
  }
  if (searchInputElement) {
    'use strict';
    var MAX_PREDICTIONS_COUNT = 5;
    var searchTerms = searchInputElement.getAttribute("searchTerms");
    if (searchTerms) {
      var terms = searchTerms.split(';');
      for (var y = 0; y < terms.length; y++) {
        dictionary.push({
          word: terms[y],
          realWord: terms[y],
          weight: 100
        });
      }
    }
    var searchTermCorrections = searchInputElement.getAttribute("searchTermCorrections");
    if (searchTermCorrections) {
      var corrections = searchTermCorrections.split(';');
      for (var y = 0; y < corrections.length; y++) {
        var correction = corrections[y].split(',');
        dictionary.push({
          word: correction[0],
          realWord: correction[1],
          weight: 100
        });
      }
    }
    function attachListeners() {
      searchInputElement.addEventListener('keyup', function (event) {
        var value = event.target.value.toUpperCase(),
          predictions = predict(value) || [];
        var results = "";
        if (predictions.length > 0) {
          predictionsElement.style.display = 'block';
          for (var z = 0; z < predictions.length; z++) {
            results += '<a onclick="javascript: setPredictiveTerm(\'' + predictions[z] + '\')">' + predictions[z] + '</a><br />';
          }
          predictionsElement.innerHTML = results;
        } else {
          predictionsElement.style.display = 'none';
        }
      });
      searchInputElement.addEventListener('keyup', function (event) {
        if (event.keyCode == 13) {
          searchButtonElement.click();
        }
      });
      searchButtonElement.addEventListener('click', function (event) {
        var value = searchInputElement.value.toUpperCase();
        var searchTerms = searchInputElement.getAttribute("searchTerms");
        if (searchTerms) {
          var terms = searchTerms.split(';');
          var descriptions = document.querySelectorAll('.accepted-insurance__left-content p');
          descriptions.forEach(function (item) {
            item.style.display = "none";
          });
          if (terms.includes(value.toUpperCase())) {
            document.getElementById("acceptedInsuranceText").style.display = "inline-flex";
          } else {
            document.getElementById("declinedInsuranceText").style.display = "inline-flex";
          }
        }
      });
    }
    function insertPredictiveTerm(word) {
      searchInputElement.value = word;
    }
    function buildMap() {
      var item, pathArray;
      for (var i = 0; i < dictionary.length; i++) {
        item = dictionary[i];
        pathArray = item.word.split('');
        addItemToMap(map, pathArray, item.weight, i);
      }
      ;
    }
    ;
    function addItemToMap(mapNode, pathArray, weight, index) {
      var letter;
      if (pathArray && pathArray.length) {
        letter = pathArray.shift();
        if (mapNode[letter]) {
          managePredictions(mapNode[letter].predictions, index);
        } else {
          mapNode[letter] = {
            predictions: [index],
            children: {}
          };
        }
        addItemToMap(mapNode[letter].children, pathArray, weight, index);
      }
    }
    ;
    function managePredictions(predictions, index) {
      var insertionIndex = getInsertionIndex(predictions, index);
      predictions.splice(insertionIndex, 0, index);
      if (predictions.length > MAX_PREDICTIONS_COUNT) {
        predictions = predictions.splice(-1, 1);
      }
    }
    ;
    function getInsertionIndex(array, index) {
      var low = 0,
        high = array.length,
        middle;
      while (low < high) {
        middle = low + high >>> 1;
        if (dictionary[array[middle]].weight > dictionary[index].weight) {
          low = middle + 1;
        } else {
          high = middle;
        }
      }
      return low;
    }
    ;
    function predict(searchTerm) {
      var predictionObject = findPredictions(searchTerm.split(''), map),
        result = [];
      if (predictionObject) {
        for (var i = 0; i < predictionObject.predictions.length; i++) {
          result.push(dictionary[predictionObject.predictions[i]].realWord);
        }
        ;
        result = result.reduce(function (accumulator, current) {
          if (!accumulator.find(function (item) {
            return item === current;
          })) {
            accumulator.unshift(current);
          }
          return accumulator;
        }, []);
        return result;
      }
    }
    ;
    function findPredictions(searchTermArray, object) {
      var pathArray, key;
      if (searchTermArray && searchTermArray.length) {
        key = searchTermArray.shift();
        if (object[key] && object[key].children && searchTermArray && searchTermArray.length) {
          return findPredictions(searchTermArray, object[key].children);
        } else {
          return object[key];
        }
      }
    }
    ;
    buildMap();
    attachListeners();
  }
});
function setPredictiveTerm(word) {
  document.getElementById("insurance-search").value = word;
  document.getElementById("predictions").style.display = 'none';
  document.getElementById("insurance-search-button").click();
}